var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.541,
    height: 13.935,
    viewBox: "0 0 12.541 13.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-import",
    transform: "translate(-6 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M18.787,15.148l2.787-3.484h-2.09V4H18.09v7.664H16Z",
    transform: "translate(-6.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M17.148,18H14.361v1.393h2.787v6.271H7.393V19.393H10.18V18H7.393A1.4,1.4,0,0,0,6,19.393v6.271a1.4,1.4,0,0,0,1.393,1.393h9.754a1.4,1.4,0,0,0,1.393-1.393V19.393A1.4,1.4,0,0,0,17.148,18Z",
    transform: "translate(0 -9.123)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import_icon.06a7440274c1ce1a8d7b09e2c57a7b8f.svg";
export { ForwardRef as ReactComponent };